import React from 'react';
import { Outlet, Link } from 'react-router-dom';
import logoadmin from '../assets/logoadminweb.png';
import logonameweb from '../assets/logonameweb.png'

// const HeaderFooter = () => {
//     return (
//         <div style={{
//             minHeight: '100vh',
//             display: 'flex',
//             flexDirection: 'column',
//             background: '#fff'
//         }}>

//             {/* HEADER */}
//             {/* <header style={{
//                 padding: '20px 40px',
//                 background: '#ffc600',
//                 borderBottom: '1px solid #eee',
//                 display: 'flex',
//                 justifyContent: 'center',
//                 alignItems: 'center',
//                 position: 'relative',
//                 minHeight: '40px'
//             }}>
//                 <img
//                     src={logoadmin}
//                     alt="Shortzz Logo"
//                     className="login-logo"
//                     style={{
//                         height: 50,
//                         objectFit: 'contain',
//                         borderRadius:'20'
//                     }}
//                 />
//                 <img
//                     src={logonameweb}
//                     alt="Shortzz Logo"
//                     className="login-logo"
//                     style={{
//                         height: 50,
//                         objectFit: 'contain',
//                         borderRadius:'20'
//                     }}
//                 />
                
//             </header> */}

//             <header style={{
//                 position:'fixed',
//                 padding: 15,
//                 width: '100%',
//                 background: '#353535',
//                 borderBottom: '1px solid #eee',
//                 display: 'flex',
//                 justifyContent: 'center',
//                 alignItems: 'center',
//                 minHeight: '40px'
//             }}>

//                 <div style={{
//                     display: 'flex',
//                     flexDirection: 'row',
//                     alignItems: 'center',
//                     justifyContent: 'center',
//                     gap: 10
//                 }}>
//                     <img
//                         src={logoadmin}
//                         alt="Shortzz Logo"
//                         style={{
//                             height: 60,
//                             width: 'auto',
//                             objectFit: 'contain'
//                         }}
//                     />

//                     <img
//                         src={logonameweb}
//                         alt="Shortzz Name"
//                         style={{
//                             height: 50,
//                             width: 'auto',
//                             objectFit: 'contain'
//                         }}
//                     />
//                 </div>

//             </header>


//             {/* PAGE CONTENT */}
//             <main style={{
//                 flex: 1,
//                 padding: '30px 40px'
//             }}>
//                 <Outlet />
//             </main>

//            <footer style={{
//     position: 'fixed',
//     bottom: 0,
//     left: 0,
//     width: '100%',
//     padding: 20,
//     background: '#353535',
//     color: '#fff',
//     textAlign: 'center',
//     fontSize: 16,
//     fontWeight: 500,
//     flexShrink: 0,
//     zIndex: 1000,
//     boxSizing: 'border-box'
// }}>
//     <p style={{
//         margin: 0,
//         color: '#fff',
//         fontSize: 18,
//         fontWeight: 'bold'
//     }}>
//         Copyright ©2026 GoShortz • All Rights Reserved.
//     </p>
// </footer>

//         </div >
//     );
// };

const HeaderFooter = () => {
    return (
        <div style={{
            height: '100vh',
            display: 'flex',
            flexDirection: 'column',
            background: '#fff',
            overflow: 'hidden'
        }}>

            {/* HEADER */}
            <header style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                padding: 15,
                background: '#353535',
                // background: '#ffc600',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: 40,
                zIndex: 1000,
                boxSizing: 'border-box'
            }}>
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: 10
                }}>
                    <img
                        src={logoadmin}
                        alt="Shortzz Logo"
                        style={{ height: 60, objectFit: 'contain' }}
                    />

                    <img
                        src={logonameweb}
                        alt="Shortzz Name"
                        style={{ height: 40, objectFit: 'contain' }}
                    />
                </div>
            </header>

            {/* CONTENT ONLY SCROLL */}
            <main style={{
                flex: 1,
                marginTop: 90,
                marginBottom: 65,
                padding: '30px 40px',
                overflowY: 'auto',
                overflowX: 'hidden'
            }}>
                <Outlet />
            </main>

            {/* FOOTER */}
            <footer style={{
                position: 'fixed',
                bottom: 0,
                left: 0,
                width: '100%',
                padding: 10,
                background: '#353535',
                // background: '#ffc600',
                color: '#fff',
                textAlign: 'center',
                zIndex: 1000,
                boxSizing: 'border-box'
            }}>
                <p style={{
                    margin: 0,
                    color: '#fff',
                    fontSize: 18,
                    fontWeight: 'bold'
                }}>
                    Copyright ©2026 GoShortz • All Rights Reserved.
                </p>
            </footer>

        </div>
    );
};

export default HeaderFooter;